import React from "react";
import styles from "./Maintenance.module.scss";
export function Maintenance({ description }) {
    return (React.createElement("div", { className: styles.main },
        React.createElement("div", { className: styles.title }, "Sorry, but you can't access application"),
        React.createElement("div", { className: styles.description }, description)));
}
